import React, {PureComponent} from 'react';
import {NavLink} from 'react-router-dom';
// import {
//   Home as HomeIcon, Hash as LiveIcon, File as EventIcon,
//   TrendingUp,
//   Users,
//   Wind,
// } from 'react-feather';

import HomeIcon from 'react-feather/dist/icons/home'
import LiveIcon from 'react-feather/dist/icons/hash'
import EventIcon from 'react-feather/dist/icons/file-text'

import {connect} from 'react-redux';
import style from '../../css/NavBar.css';


class NavBar extends PureComponent {

  render() {
    let {loadingPage} = this.props;

    return (
        <nav id="app-nav">
          <div className="container-fluid d-flex align-items-center justify-content-between">
            <ul>
              <li>
                <NavLink to="/" exact activeClassName={'active'}>
                  <HomeIcon/>
                  <span className={'d-none d-sm-inline'}> 首页 </span>
                </NavLink>
              </li>

              <li>
                <NavLink to="/lives" activeClassName={'active'}>
                  <LiveIcon/>
                  <span className={'d-none d-sm-inline'}> Live </span>
                </NavLink>
              </li>

              {/*<li>*/}
              {/*  <NavLink to="/lives" activeClassName={'active'}>*/}
              {/*    <Users/>*/}
              {/*    <span className="hidden-xs"> 人物 </span>*/}
              {/*  </NavLink>*/}
              {/*</li>*/}

              <li>
                <NavLink to="/events" activeClassName={'active'}>
                  <EventIcon/>
                  <span className={'d-none d-sm-inline'}> 专栏 </span>
                </NavLink>
              </li>

              {/*<li>*/}
              {/*  <NavLink to="/trending" activeClassName={'active'}>*/}
              {/*    <TrendingUp/>*/}
              {/*    <span className="hidden-xs"> 趋势 </span>*/}
              {/*  </NavLink>*/}
              {/*</li>*/}

              {/*<li>*/}
              {/*  <NavLink to="/trending" activeClassName={'active'}>*/}
              {/*    <Wind/>*/}
              {/*    <span className="hidden-xs"> 茶馆 </span>*/}
              {/*  </NavLink>*/}
              {/*</li>*/}

              {/*<li>*/}
              {/*  <NavLink to="/lives" activeClassName={'active'}>*/}
              {/*    <LiveIcon/>*/}
              {/*    <span className="hidden-xs"> Live </span>*/}
              {/*  </NavLink>*/}
              {/*</li>*/}
            </ul>

            {loadingPage.loading ? (
                <div className={"spinner-border text-primary spinner-border-md mr-2 " + style.spinner} role="status">
                  <span className="sr-only">Loading...</span>
                </div>
            ) : null}

            <div class="d-flex">

              <form class="form-inline search-form" action="/search">
                <input class="form-control input-sm mr-sm-2" name="q"
                       type="search" placeholder="搜索"
                       aria-label="搜索"
                />
              </form>
            </div>
          </div>
        </nav>
    )
  }
}


export default connect(({loadingPage}) => ({loadingPage}))(NavBar);
